// mui
import { alpha, Box, Stack, styled } from "@mui/material";
import { useContext } from "react";
import Logo from "src/components/Logo";
import { NAVBAR } from "src/config";
import useResponsive from "src/hooks/useResponsive";
import cssStyles from "src/utils/cssStyles";

import Context, { ContextType } from "../../context";
import NavbarDrawerButton from "./NavbarDrawerButton";

const HeaderStyle = styled(Stack)<{ isDesktop?: boolean }>(({ theme, isDesktop }) => {
	const { palette } = theme;
	const colorGradienst = isDesktop
		? palette.mode === "dark"
			? palette.background.default
			: palette.background.paper
		: palette.background.paper;
	return {
		...cssStyles(theme).bgGradient({
			direction: "bottom",
			startColor: `${alpha(colorGradienst, 1)}`,
			endColor: `${alpha(colorGradienst, 0.4)}`
		}),
		position: "fixed",
		zIndex: 100,
		width: NAVBAR.DASHBOARD_WIDTH - 1,
		...cssStyles(theme).bgBlur({
			opacity: 0.4,
			blur: 0.8,
			color: colorGradienst
		}),
		boxShadow: "none"
	};
});

type Props = {
	collapseClick: boolean;
	onToggleCollapse: VoidFunction;
};

export default function NavbarHeader({ collapseClick, onToggleCollapse }: Props) {
	const { isCollapse }: ContextType = useContext<ContextType>(Context);
	const isDesktop = useResponsive("up", "lg");

	return (
		<HeaderStyle
			alignItems='center'
			direction={isCollapse ? "column" : "row"}
			isDesktop={isDesktop}
			justifyContent={"space-between"}
			spacing={3}
			sx={{
				pt: 3,
				px: 2.5,
				...(isCollapse && {
					alignItems: "center",
					width: NAVBAR.DASHBOARD_COLLAPSE_WIDTH - 1
				})
			}}
		>
			<Logo />

			{isDesktop && (
				<NavbarDrawerButton collapseClick={collapseClick} onToggleCollapse={onToggleCollapse} />
			)}

			<Box />
		</HeaderStyle>
	);
}
